import { message } from 'antd'


export const AntdMessageError = (msg) => {
  return message.error(msg)
}